<template>
  <div>
    <CommonSection />
    <div class="container-fluid">
      <v-row>
        <v-col>
          <card shadow type="secondary">
            <div slot="header" class="bg-white border-0">
              <h3 class="mb-0 float-left card-header-name">Terpene Information List</h3>
              <router-link :to="{ path: 'product-parameter/create' }" class="float-right mt-0">
                <v-tooltip bottom :color="$vuetify.theme.themes.light.tooltipColor">
                  <template v-slot:activator="{ on: tooltip, attrs }">
                    <img
                      class="mr-2"
                      v-bind="attrs"
                      v-on="{ ...tooltip }"
                      src="@/assets/images/Plus.svg"
                    />
                  </template>
                  <span>Add Terpene Information</span>
                </v-tooltip>
              </router-link>
            </div>
            <v-card>
              <v-card-title :class="$vuetify.breakpoint.mdAndUp ? 'col-4 float-right' : 'col-12'">
                <v-text-field
                  class="search-text-field"
                  v-model="search"
                  append-icon="search"
                  label="Search by Name"
                  single-line
                  hide-details
                  v-debounce:1s="searchFilter"
                  :debounce-events="['click', 'keydown']"
                ></v-text-field>
              </v-card-title>
              <v-data-table
                class="float-left width-100"
                :headers="headers"
                :items="parameters"
                :loading="loading"
                loading-text="Loading... Please wait"
                :page.sync="page"
                :items-per-page="itemsPerPage"
                hide-default-footer
              >
                <template v-slot:[`item.name`]="{ item }">
                  <div>{{ item.name }}</div>
                </template>
                <template v-slot:[`item.actions`]="{ item }">
                  <router-link :to="{ path: 'product-parameter/' + item._id }">
                    <v-tooltip bottom :color="$vuetify.theme.themes.light.tooltipColor">
                      <template v-slot:activator="{ on: tooltip, attrs }">
                        <img
                          v-bind="attrs"
                          v-on="{ ...tooltip }"
                          class="mr-2 edit-icon"
                          src="@/assets/images/Edit.svg"
                        />
                      </template>
                      <span>Edit</span>
                    </v-tooltip>
                  </router-link>
                  <delete-component
                    :id="item._id"
                    module="ProductParameter/delete"
                    @requestDeleted="requestDeleted"
                  ></delete-component>
                </template>
              </v-data-table>
              <v-card-actions class="justify-end pt-2 float-left width-100">
                <v-pagination circle v-model="page" :length="pageCount"></v-pagination>
              </v-card-actions>
            </v-card>
          </card>
        </v-col>
      </v-row>
    </div>
  </div>
</template>

<script>
import CommonSection from "@/components/CommonHeader";
import DeleteComponent from "@/components/DeleteComponent";
import { ProductparameterService } from "@/services";

export default {
  name: "ProductParameter",
  components: {
    CommonSection,
    DeleteComponent,
  },
  data: () => ({
    page: 1,
    pageCount: 0,
    loading: true,
    itemsPerPage: 50,
    search: "",
    parameters: [],
    headers: [
      {
        text: "Name",
        align: "start",
        value: "name",
      },
      { text: "Actions", value: "actions", sortable: false },
    ],
  }),
  watch: {
    page() {
      this.initialize();
    },
  },
  created() {
    this.initialize();
  },
  methods: {
    async initialize() {
      this.loading = true;
      const params = {
        limit: parseInt(this.itemsPerPage),
        skip:
          parseInt(this.page) * parseInt(this.itemsPerPage) -
          parseInt(this.itemsPerPage),
        name: this.search,
      };
      const parameterList = await ProductparameterService.list(params);
      if (parameterList.data.data.length > 0) {
        this.pageCount = Math.ceil(
          parameterList.data.option[0].count / this.itemsPerPage
        );
        this.parameters = parameterList.data.data;
        this.loading = false;
      } else {
        if (this.page !== 1) {
          this.page--;
        }
        this.loading = false;
        this.parameters = [];
      }
    },
    async handleClick(value) {
      this.$router.push("/product-parameter/" + value._id);
    },
    searchFilter() {
      this.page = 1;
      this.initialize();
    },
    requestDeleted() {
      this.initialize();
    },
  },
};
</script>
